/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import Vue from "vue";
import VueHead from "vue-head";
import VueCookies from "vue-cookies";
import Datetime from "vue-datetime";
import axios from "axios";
import VeeValidate, { Validator } from "vee-validate";

import VeeValidateJaLocale from "vee-validate/dist/locale/ja";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import Utils from "./utils/utils";
import Config from "./config";

require("url-search-params-polyfill");

console.log(`main: %o`, process.env);

// APIのbaseURL
axios.defaults.baseURL = Config.API_BASE_URL;

// API送信時にtimestamp追加
axios.interceptors.request.use(function(config) {
  if (typeof config.params === "undefined") {
    config.params = {};
  }
  if (typeof config.params === "object") {
    if (
      typeof URLSearchParams === "function" &&
      config.params instanceof URLSearchParams
    )
      config.params.append("_", Date.now());
    else config.params._ = Date.now();
  }

  return config;
});

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    // 認証エラー時の処理
    if (error.response.status === 401) {
      console.log(error);

      alert("401:Unauthorized");
      store.dispatch("logout");
      store.commit("RESET");
      router.push("/login");
      // システムエラー時の処理
    } else if (error.response.status === 500) {
      // Vue.toasted.clear()
      // Vue.toasted.error(error.response.data.message)
    }
    return Promise.reject(error);
  }
);

Vue.prototype.$axios = axios;

Vue.use(VueCookies);
Vue.use(VueHead);
Vue.use(Datetime);

// Install the Plugin.
Vue.use(VeeValidate);

// Localize takes the locale object as the second argument (optional) and merges it.
Validator.localize("ja", VeeValidateJaLocale);

Vue.mixin(Utils);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
